import { ref } from 'vue';

export const showing_settings_modal = ref(false);

export function show_settings_modal() {
    showing_settings_modal.value = true;
}

export function hide_settings_modal() {
    showing_settings_modal.value = false;
}
